// extracted by mini-css-extract-plugin
export default {"cardTitle":"style_cardTitle__J5cqF","cabecalho":"style_cabecalho__zvVrv","separador":"style_separador__bSxOM"};